import * as Scrivito from "scrivito"

// URL has following structure:
// {HOST}/{SITE_ID}/{SCRIVITO_URL_PART}
// e.g https://schako-integration.justrelate.io/de/productpage
// HOST: https://schako-integration.justrelate.io
// SITE_ID: de
// SCRIVITO_URL_PART: productpage

export const baseUrlForSite = (siteId: string): string => {
  if (!import.meta.env.VITE_SCRIVITO_ORIGIN) {
    throw new Error(
      "baseUrlForSite: You have to define VITE_SCRIVITO_ORIGIN in your environment variables"
    )
  }
  const expectedHomepage = Scrivito.Obj.onSite(siteId)
    .where("_objClass", "equals", "Homepage")
    .take(1)[0]
  const prefix = expectedHomepage
    ? String(expectedHomepage.get("siteUrlPrefix"))
    : siteId
  return new URL(prefix, import.meta.env.VITE_SCRIVITO_ORIGIN).toString()
}
